
import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { RankingData, RankingSubscriptionData } from '../types';

/**
 * typeguard for RankingQuery
 * @param RankingQuery object passed to transformer
 */
export const isValidRanking = (obj: RankingData): boolean => Boolean(obj?.data?.getRankingWidget && !isEmptyObject(obj.data.getRankingWidget));
export const isValidRankingSubscription = (obj: RankingSubscriptionData): boolean => Boolean(obj?.data?.onUpdateRankingWidgetByTourId && !isEmptyObject(obj.data.onUpdateRankingWidgetByTourId));
